import { render } from "./BaseCommentItem.vue?vue&type=template&id=a238f194&scoped=true"
import script from "./BaseCommentItem.vue?vue&type=script&lang=js"
export * from "./BaseCommentItem.vue?vue&type=script&lang=js"

import "./BaseCommentItem.vue?vue&type=style&index=0&id=a238f194&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a238f194"]])

export default __exports__